import React, { useState } from "react";
import styles from "./Header.module.sass";

import User from "./User";
import { useUser } from "../../context";

const Header = ({ onOpen }) => {
	const [visible, setVisible] = useState(false);
	const {
		brand,
		tokens: { group },
	} = useUser();
	const handleClick = () => {
		onOpen();
		setVisible(false);
	};

	return (
		<header className={styles.header}>
			<button className={styles.burger} onClick={() => handleClick()}></button>
			{group === "admin" && !brand ? (
				<div className={styles.spacer} />
			) : (
				<div className={styles.control}></div>
			)}
			<User className={styles.user} />
		</header>
	);
};

export default Header;
